<div class="disable-confirm-container">
  <p class="disable-confirm-title alt-inter-bold alt-size-20">{{"OPORTUNITIES.warning-delete" | translate }} </p>
  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold ">{{"OPORTUNITIES.warning-delete-text" | translate}}
  </p>
  <small class="disable-confirm-text-two alt-size-14 alt-inter-regular">{{"OPORTUNITIES.warinig-delete-sub" |
    translate}}</small>


  <div class="btn-proceed alt-flex-end">
    <button  class="btn-cancel alt-color-bran1 pointer alt-size-14 alt-inter-medium " type="button"
      [mat-dialog-close]="false">{{"USERS.go-back"
      | translate | uppercase }}</button>
    <button  class="btn-agree alt-color-bran1 pointer alt-size-14 alt-inter-medium " type="button" [mat-dialog-close]="true"
      (click)="confirmDelete()">{{"COMPANY.erase-agreed" | translate | uppercase
      }}</button>
  </div>
</div>
